import { render, staticRenderFns } from "./OnboardingQuestions.vue?vue&type=template&id=01937567&scoped=true&"
import script from "./OnboardingQuestions.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01937567",
  null
  
)

export default component.exports